import { map } from 'lodash';

class DayListController {

    constructor($rootScope, $stateParams, $scope, $state, $timeout, dayService, messageService, access, configService) {
        this.$scope = $scope;
        this.$state = $state;
        this.dayService = dayService;
        this.messageService = messageService;
        this.access = access;
        this.configService = configService;
        this.$stateParams = $stateParams;
        this.$rootScope = $rootScope;
        $scope.treeOptions = {
            dropped: function (sourceNodeScope) {
                $timeout(() => sourceNodeScope.source.nodesScope.$parent.$parent.$ctrl.saveStructure());
            }
        };
    }

    $onInit () {
        this.filtertext = this.$stateParams.filtertext || null;
        if (this.filtertext) {
            this.isFiltered = true;
        }

        if (this.days) {
            this.activeTab = 'list';
        }

        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal !== oldVal) {
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        scope.$ctrl.days = undefined;
                        scope.$ctrl.dayService.search(scope.$ctrl.filtertype, scope.$ctrl.filtertext, newVal).then(response => {
                            scope.$ctrl.days = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        scope.$ctrl.dayService.findAll(newVal, scope.per_page)
                            .then(list => scope.$ctrl.days = list);
                    }
                }
            }
        );
    }

    updatePaging () {
        this.$scope.per_page = this.days.per_page;
        this.$scope.current_page = this.days.current_page;
        this.$scope.total = this.days.total;
    }

    onDelete (day) {
        return this.dayService.delete(day.id)
            .then(() => {
                this.messageService.success(`The day <strong>${day.name}</strong> was successfully deleted.`);
                this.messageService.push();
            })
            .catch((error) => {
                this.messageService.failure(`The day <strong>${day.name}</strong> could not be successfully deleted: ${error.statusText}`);
                this.messageService.push();
            })
            .then(() => {
                let page = this.days.current_page;
                this.days = [];
                this.loading = true;
                return this.dayService.findAll(page).then(response => {
                    this.days = response;
                    this.loading = false;
                });
            });
    }

    saveStructure () {
        this.dayService.reconstruct(map(this.days.tree, 'id'))
            .then(() => {
                this.messageService.success(`This event order has been successfully saved.`);
                this.messageService.push();
                this.messageService.autoClear();
            })
            .catch(() => {
                this.messageService.failure(`This event order could not be successfully saved: ${error.statusText}`);
                this.messageService.push();
            });
    }

    toggleActive (day) {
        this.dayService.toggleActive(day.id)
            .catch(
                (error) => {
                    this.messageService.failure(`The day <strong>${day.name}</strong> could not be successfully toggled (active): ${error.statusText}`);
                    this.messageService.push();
                }
            )
            .then(
                () => day.status = !day.status
            );
    }

    toggleVisible (day) {
        this.dayService.toggleVisible(day.id)
            .catch(
                (error) => {
                    this.messageService.failure(`The day <strong>${day.name}</strong> could not be successfully toggled (visibility): ${error.statusText}`);
                    this.messageService.push();
                }
            )
            .then(
                () => day.secret = !day.secret
            );
    }

    filter () {
        if (!this.loading && this.filtertext) {
            this.startFilter();
            this.dayService.search(this.filtertype, this.filtertext).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.dayService.findAll(1, 20).then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            case 'cat':
                this.filtertext = this.categories.flat[0].id;
                break;
            case 'status':
                this.filtertext = '1';
                break;
            case 'secret':
                this.filtertext = '0';
                break;
            default:
                this.filtertext = '';
                break;
        }
    }

    startFilter () {
        this.days = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.days = response;
        this.updatePaging();
        this.loading = false;
    }

    updatePriority (event) {
        if (!event || event.priority === '' || event.priority > 999 || event.priority === undefined){
            return false;
        }
        this.updateWait(event);
    }

    updateWait(item){
        if (item.priority.match(/[^0-9]+/g)) return;
        item.updating = false;
        clearTimeout(item.trigger);
        item.trigger = setTimeout(() => {this.trigger(item);}, 1000);
    }
    
    update(item){
        this.trigger(item);
    }
    
    trigger(item){
        item.trigger = undefined;
        item.updating = true;
    
        this.dayService.updatePriority(item).then(() =>{
          item.updating = false;
        });
    }
}

DayListController.$inject = ['$rootScope', '$stateParams', '$scope', '$state', '$timeout', 'dayService', 'messageService', 'access', 'configService'];

export default DayListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/days/controllers/day.list.controller.js